import { all, fork } from "redux-saga/effects";

/**
 * An object with base async action types
 * @typedef {object} Actions
 * @property {string} request
 * @property {string} success
 * @property {string} failure
 * @property {string} pending
 * @property {string} reset
 * */

/**
 * A function constructing simple side effect action types.
 * @param {string} type a base string as action type
 * @returns {Actions}
 * */
export const createActionTypes = (type = "test") => ({
  request: `${type}/request`,
  success: `${type}/success`,
  failure: `${type}/failure`,
  pending: `${type}/pending`,
  reset: `${type}/reset`,
});

export const combineSagas = (sagas) =>
  function* create() {
    yield all(sagas.map((saga) => fork(saga)));
  };
